import * as React from 'react';
import { localizedString } from '@locale/index';
import { BodyGroup, HelperPopover, NiInput } from '@component/index';
import { isEqual } from '@lib/index';
import { defaultLineHeight } from '@config/styledVar';

interface DescriptionProps {
  disabled?: boolean;
  title?: string;
  placeholder?: string;
  data: string;
  onChange: (next: string) => void;
}

interface DescriptionState {

  data: string;
}

export class Description extends React.Component<DescriptionProps, DescriptionState> {
  state = {
    data: ''
  };
  componentDidMount() {
    this.onInit();
  }

  shouldComponentUpdate(nextProps: any, nextState: any, nextContext: any) {
    if (!isEqual(nextProps, this.props)) {

      setTimeout(this.onInit, 100);
      return true;
    }

    return !isEqual(this.state, nextState);
  }

  onInit = () => {
    this.setState({ data: this.props.data });
  }

  render() {
    const state = this.state;
    const props = this.props;

    return <BodyGroup title={props.title || localizedString('common_description')}
      titleExtra={<HelperPopover localizedKey="frame_hint_description" />}
      extra={[]}>
      <NiInput
        disabled={props.disabled}
        style={{ height: defaultLineHeight }}
        value={state.data}
        placeholder={props.placeholder || localizedString('description_placeholder')}
        onChange={this.handleChange}
        onBlur={this.onBlur}
        onKeyDown={this.onKeyDown}
      />
    </BodyGroup>;
  }

  handleChange = (e: any) => {
    this.setState({
      data: e.target.value
    });
  }

  onBlur = () => {
    this.props.onChange(this.state.data);
  }

  onKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {

    if (e.which === 13) {
      this.onBlur();
    }
  };
}
